import { url } from '@/api/base-url'

export async function requestHelp (data) {
  const res = await url.post(`pedidodeajuda`, data)
  return res.data
}
